var map = {
	"./10beecoins.svg": "2ca7",
	"./15beecoins.svg": "50c9",
	"./20beecoins.svg": "523a",
	"./50-50.svg": "a68b",
	"./5beecoins.svg": "26a0",
	"./asertivoro.png": "3c77",
	"./beecoin-3.svg": "ae57",
	"./comodin-001.svg": "f430",
	"./comodin-002.svg": "bd2f",
	"./comodin-003.svg": "87ac",
	"./comodin-004.svg": "bd04",
	"./comodin-50.png": "5950",
	"./comodin-pistas.png": "d435",
	"./desafios-pista.svg": "c3e3",
	"./desafios-varita.svg": "c1ea",
	"./estrellas-calificacion.svg": "ece7",
	"./hand.png": "ae12",
	"./icon-fist.png": "d3c7",
	"./lectofilo.png": "6d97",
	"./pistas.svg": "3bef",
	"./tag--tienes.png": "f1fe",
	"./tag-precio.png": "4fbb",
	"./tag-precio_.png": "a027",
	"./tag-tienes.png": "aa5a",
	"./wildcard-used.svg": "87bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d002";